// extracted by mini-css-extract-plugin
module.exports = {"onHoldMembership":"styles_onHoldMembership__30vas"};